import script from "./ToastList.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastList.vue?vue&type=script&setup=true&lang=js"

import "./ToastList.vue?vue&type=style&index=0&id=5e9fc5e8&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/aaa/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9fc5e8"]])

export default __exports__